export default __webpack_public_path__ + "static/media/outfit_1.bfb463ba.png";